import styled from 'styled-components';
import theme from 'theme/theme';
import Flex from '../Flex';

const Card = styled(Flex)`
  position: relative;
  background: ${theme.colors.white};
  box-shadow: ${theme.shadows.default};
  width: 100%;
  height: 100%;
`;

export default Card;
